import React from "react";

import Details from "./Details";
import Recipient from "./Recipient";

import { CreateNFeContext } from "../Context";

export default (props) => {
  const context = React.useContext(CreateNFeContext)
  if(context.step != "nfe-details"){
    return <React.Fragment />
  }
  return <div className="row">
    <div className="col-md-6 col-xs-12 col-lg-6">
      <Details simplified={props.simplified} />
    </div>
    <div
      className="col-md-6 col-xs-12 col-lg-6 mx-auto"
      style={{
        display: "flex",
        justifyContent: 'center',
      }}
    >
      <Recipient />
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/index.jsx